import React from 'react';
import SwishFormBlock from './SwishFormBlock';
import {useGetCompanyRegistrationsQuery, useSwishFormBlockQuery} from "@apps/Shared/GraphQL/generated";
import {SwishFormProps} from "./types";
import {getLocale} from "@apps/Shared/Utils/Utils";
import {CompanyRegistrationsBlockProps} from "@apps/CompanyRegistrations/types";
function App(): JSX.Element {
    const hiddenInput = document.querySelector('.js-swish-form-block');
    const id = Number((hiddenInput as HTMLInputElement).value);
    const formReferenceId = Number((hiddenInput as HTMLInputElement).dataset.formReferenceId);
    const hasFormReference = Number.isFinite(formReferenceId) && formReferenceId > 0;
    const locale = getLocale();
    const {data} = useSwishFormBlockQuery({
        id: id,
        locale: [locale]
    });
    const {data: formReferenceData} = useGetCompanyRegistrationsQuery({
        id: formReferenceId,
        locale: [locale]
    }, {
        enabled: hasFormReference
    });
    
    if (data?.Content?.items?.[0]) {
        const item: any = data.Content.items[0];
        const formReferenceBlock = formReferenceData?.CompanyRegistrationsBlockModel?.items?.length
            ? formReferenceData?.CompanyRegistrationsBlockModel?.items[0]
            : null;
        const settings = formReferenceData?.StartPageModel?.items?.length
            ? formReferenceData?.StartPageModel?.items[0]
            : null;
        const companyRegistrationsProps: CompanyRegistrationsBlockProps | undefined = formReferenceBlock
            ? {
                buttonText: formReferenceBlock?.ButtonText as string,
                extra1: formReferenceBlock?.Extra1?.Html,
                extra2: formReferenceBlock?.Extra2?.Html,
                extra3: formReferenceBlock?.Extra3?.Html,
                extra4: formReferenceBlock?.Extra4?.Html,
                extra5: formReferenceBlock?.Extra5?.Html,
                helpText: formReferenceBlock?.HelpText?.Html,
                form: formReferenceBlock?.Form as string,
                termsAndConditions: settings?.StandardTermsAndConditions?.Html,
                customTermsAndConditions: formReferenceBlock?.CustomTermsAndConditions?.Html,
                termsAndConditionsButtons: formReferenceBlock?.CustomTermsAndConditionsButton
            }
            : undefined;
        const props: SwishFormProps = {
            heading: item.Heading,
            companyRegistrationsProps: companyRegistrationsProps
        };
        return (
            <SwishFormBlock {...props} />
        );
    } else {
        return <></>;
    }
}
export default App;
